import React from "react";
import { isMyCarLegToParkAndRide } from "../../../tools/parkAndRideOsmTags.tools";
import { getTransportModeGroupForItineraryLeg, TransportModeGroup } from "../../../tools/TransportModeGroupsTools";
import { type ItineraryLegDTO } from "../../../types/dtos/api/itinerary/itinerary.dto";
import { getItineraryDetailsLegPillColor, getItineraryDetailsLegPillLabel, hasNonEmptyText, isSimpleMobilityLegMode } from "./itineraryDetails.tools";

interface ItineraryDetailsLegPillProps { "leg": ItineraryLegDTO }

/** Shared chrome for filled route / direction pills in itinerary leg title rows. */
const ITINERARY_DETAILS_LEG_PILL_CLASS_NAME =
    "text-xs font-semibold mr-2 rounded-md rounded-bl-none text-white px-2";

const ItineraryDetailsLegPill: React.FC<ItineraryDetailsLegPillProps> = ( { leg } ) => {
    const modeGroup = getTransportModeGroupForItineraryLeg( leg );

    if ( isMyCarLegToParkAndRide( leg ) ) {
        return (
            <span
                aria-hidden={true}
                className={ITINERARY_DETAILS_LEG_PILL_CLASS_NAME}
                style={{ "backgroundColor": getItineraryDetailsLegPillColor( leg ) }}
            >
                →
            </span>
        );
    }

    if ( isSimpleMobilityLegMode( leg.mode ) ) {
        return null;
    }

    const pillLabel = getItineraryDetailsLegPillLabel( leg );

    if ( hasNonEmptyText( pillLabel ) ) {
        return (
            <span
                className={ITINERARY_DETAILS_LEG_PILL_CLASS_NAME}
                style={{ "backgroundColor": getItineraryDetailsLegPillColor( leg ) }}
            >
                {pillLabel}
            </span>
        );
    } else if ( [ TransportModeGroup.RENTAL, TransportModeGroup.BICYCLE, TransportModeGroup.BLABLACAR, TransportModeGroup.BLABLADAILY ].includes( modeGroup ) ) {
        return (
            <div
                className="mr-2 w-[3px] self-stretch"
                style={{ "backgroundColor": getItineraryDetailsLegPillColor( leg ) }}
            />
        );
    } else {
        return (
            <div
                className="mr-2 w-[3px] self-stretch"
                style={{ "backgroundColor": getItineraryDetailsLegPillColor( leg ) }}
            />
        );
    }
};

export default ItineraryDetailsLegPill;
